import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { Mutation } from '@apollo/client/react/components';

import SVGIcon from 'lib/images/svg-icon/svg-icon';

import close from 'four-nets/icons/svg/icon_delete_2.svg';
import plus from 'four-nets/icons/svg/icon_plus.svg';
import Input from 'four-nets/ui-v2/form/input/input';

import MyCollections from './my-collections/my-collections';
import mutation, {
    CreateCollectionImageMutation,
    CreateCollectionImageMutationVariables,
} from './mutations/create-collection-image.graphql';
import defaultStyles from './collection-image-save.scss';
import { Switch, Route } from 'react-router';

export interface Props {
    styles: typeof defaultStyles;
    imageId: string;
    onClose: () => void;
}

enum Mode {
    EXISTING = 'EXISTING',
    NEW = 'NEW',
}

interface State {
    mode: Mode;
    value: string;
}

class CollectionImageSave extends React.PureComponent<Props, State> {
    state = { mode: Mode.EXISTING, value: '' };

    render() {
        const { styles, onClose, imageId } = this.props;
        const { mode, value } = this.state;

        const buttonPanel = (
            <div>
                <button
                    className={styles.cancel}
                    onClick={() => {
                        this.setState({ mode: Mode.EXISTING, value: '' });
                    }}
                >
                    <FormattedMessage id='CANCEL' values={{ gender: 'v' }} />
                </button>
                <Mutation<CreateCollectionImageMutation, CreateCollectionImageMutationVariables> mutation={mutation}>
                    {create => (
                        <button
                            className={styles.confirm}
                            disabled={!value}
                            onClick={() => {
                                create({
                                    variables: {
                                        input: {
                                            imageId,
                                            newCollectionTitle: value,
                                        },
                                    },
                                }).then(onClose);
                            }}
                        >
                            <FormattedMessage id='CREATE_COLLECTION' />
                        </button>
                    )}
                </Mutation>
            </div>
        );

        return (
            <div className={styles.wrapper}>
                <div className={styles.header}>
                    <div className={styles.title}>
                        {mode === Mode.EXISTING ? (
                            <FormattedMessage id='ADD_TO_COLLECTION' values={{ gender: 'v' }} />
                        ) : (
                            <FormattedMessage id='CREATE_NEW_COLLECTION' values={{ gender: 'v' }} />
                        )}
                    </div>
                    <button onClick={onClose} className={styles.close}>
                        <SVGIcon src={close} />
                    </button>
                </div>
                {mode === Mode.EXISTING ? (
                    <div className={styles.scrollable}>
                        <MyCollections key={imageId} imageId={imageId} onClose={onClose} />
                    </div>
                ) : (
                    <div className={styles.inputPadding}>
                        <FormattedMessage id='SET_COLLECTION_TITLE'>
                            {message => (
                                <Input
                                    value={value}
                                    placeholder={message as string}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                        this.setState({ value: event.target.value });
                                    }}
                                />
                            )}
                        </FormattedMessage>
                    </div>
                )}
                {mode === Mode.EXISTING ? (
                    <button
                        onClick={() => {
                            this.setState({ mode: Mode.NEW });
                        }}
                        className={styles.addNew}
                    >
                        <SVGIcon style={{ image: styles.addIcon }} src={plus} />
                        <FormattedMessage id='CREATE_NEW_COLLECTION' />
                    </button>
                ) : (
                    <Switch>
                        <Route
                            path={[
                                '/catalog/vendor/:username/blog-album/:slug/:imageId',
                                '/catalog/vendor/:username/:imageId',
                                '/blog/:username/album/:slug/:imageId',
                            ]}
                            render={() =>
                                React.cloneElement(buttonPanel, {
                                    className: `${styles.buttonPanel} ${styles.notAbsolute}`,
                                })
                            }
                        />
                        <Route render={() => React.cloneElement(buttonPanel, { className: styles.buttonPanel })} />
                    </Switch>
                )}
            </div>
        );
    }
}

export default Styled(defaultStyles)(CollectionImageSave);
